import React, { useEffect, useState } from 'react';
import { useApp } from '../../context/AppContext';
import { FilePlus, Download } from 'lucide-react';

export default function DocumentsTab({ portalUser }) {
  const { loading } = useApp();
  const [docs, setDocs] = useState([]);
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');

  const fetchDocs = async () => {
    try {
      const token = localStorage.getItem('clientToken');
      const clientId = localStorage.getItem('clientId');
      if (!token || !clientId) return;
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
      const res = await fetch(`${API_URL}/clients/${clientId}/documents`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok) {
        const data = await res.json();
        setDocs(data);
      }
    } catch (err) {
      console.error('Failed to fetch documents:', err);
    }
  };

  useEffect(() => { if (portalUser) fetchDocs(); }, [portalUser]);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return setMessage('Choose a file');
    setMessage('Uploading...');
    try {
      const token = localStorage.getItem('clientToken');
      const clientId = localStorage.getItem('clientId');
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
      const fd = new FormData();
      fd.append('file', file);
      const res = await fetch(`${API_URL}/clients/${clientId}/documents`, { method: 'POST', body: fd, headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok) {
        setMessage('Uploaded');
        setFile(null);
        await fetchDocs();
        setTimeout(() => setMessage(''), 3000);
      } else {
        const json = await res.json();
        setMessage(json.error || 'Upload failed');
      }
    } catch (err) {
      console.error('Upload error:', err);
      setMessage('Upload failed');
    }
  };

  return (
    <div style={{ display: 'grid', gap: '1rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ margin: 0, fontWeight: 600 }}>Documents & Deliverables</h2>
        <form onSubmit={handleUpload} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <input type="file" onChange={e => setFile(e.target.files[0])} />
          <button type="submit" disabled={!file} style={{ padding: '0.5rem 0.75rem', borderRadius: '0.5rem' }}><FilePlus size={14} /> Upload</button>
        </form>
      </div>

      {message && <div style={{ color: '#94a3b8' }}>{message}</div>}

      {docs.length === 0 ? (
        <div style={{ color: '#64748b' }}>No documents found</div>
      ) : (
        <div style={{ display: 'grid', gap: '0.5rem' }}>
          {docs.map(d => (
            <div key={d._id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', borderRadius: '0.5rem', background: 'rgba(15,23,42,0.3)' }}>
              <div>
                <div style={{ fontWeight: 600 }}>{d.originalName}</div>
                <div style={{ fontSize: '0.875rem', color: '#94a3b8' }}>{new Date(d.createdAt).toLocaleString()}</div>
              </div>
              <div>
                <a href={d.signedUrl || d.url} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: '#34d399' }}><Download size={14} /> Download</a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
